<template>
    <li v-if="isExternal"  :class="['nav-item']">
        <a class="nav-link" :href="this.to" target="_self">{{name}}</a>
    </li>
    <router-link v-else  :to="this.to" v-slot="{ href, route, navigate, isActive, isExactActive }">
        <li :class="['nav-item', (isActive &&isExactActive) && 'active']">
            <a class="nav-link" :href="href" @click="navigate">{{name}}</a>
        </li>
    </router-link>
</template>

<script>
    export default {
        props: ["to","name"],
        computed: {
            // newTo: function () {
            //     if(this.to.startsWith("//")){
            //         // window.location = this.to;
            //         return this.to.split('//')[1].split('/').slice(1).join('/')
            //     }else{
            //         return this.to;
            //     }
            // },
            isExternal: function () {
                return this.to.startsWith("//") || this.to.startsWith("http"); //this.to.startsWith(/^\/\/|^http/)
            }
        }
    }
</script>